
// FIX: Import `ReactNode` to resolve error "Cannot find namespace 'React'".
import type { ReactNode } from 'react';

export interface Patient {
  name: string;
  age: number;
  id: string;
  facility: string;
  avatarUrl: string;
}

export interface HealthRecord {
  id: string;
  date: string;
  recordedBy: string;
  type: 'Vitals' | 'ADL' | 'Notes' | 'Emotion' | 'Photos' | 'Physiotherapy' | 'Appointment' | 'Glasgow Coma Scale (GCS)' | 'Pain' | 'Input / Output';
  summary: string;
  images?: string[];
}

export enum HealthCategory {
  ADL = 'Activities of Daily Living',
  IO = 'Input / Output',
  INPUT = 'Input (Food/Feeding)',
  OUTPUT = 'Output (Stool/Urine)',
  EMOTIONS = 'Emotions',
  VITALS = 'Vitals',
  GCS = 'Glasgow Coma Scale (GCS)',
  PAIN = 'Pain',
  PHYSIO = 'Physiotherapy',
  APPOINTMENTS = 'Appointments',
  NOTES = 'Notes',
  IMPORTANT_NOTE = 'Important Note',
  PHOTOS = 'Photos',
}

export interface ImportantInfo {
  id: string;
  label: string;
  value: string;
  // FIX: Use `ReactNode` type.
  icon: ReactNode;
  date?: Date;
}

export interface VitalHistory {
  date: string;
  bp: { systolic: number; diastolic: number };
  hr: number;
  glucose: number;
  weight: number;
}

export type VisitStatus = 'Scheduled' | 'Completed';

export interface ImportantNote {
  id: number;
  notes: string;
  recorded_at: string;
  creator_name: string;
}

export interface ResidentVisitation {
  id: number;
  customer_id: number;
  scheduled_date: string;
  scheduled_time_slot: string;
  status: VisitStatus;
  notes: string | null;
  created_by_employee_id: number | null;
  created_at: string;
  updated_at: string;
  customer_name: string;
  created_by_name: string | null;
}

export interface VisitationInsertBody {
  customer_id: number;
  scheduled_date: string;        // 'YYYY-MM-DD' from formatLocalDate
  scheduled_time_slot: string;   // member of weekdayAppointmentSlots ∪ weekendAppointmentSlots
  status: 'Scheduled';
  notes: string;
  created_by_employee_id: number | null; // ALWAYS present; null for family, integer for staff
}

export interface VisitationStatusUpdateBody {
  id: number;
  customer_id: number;
  status: 'Completed';
}

export interface ImportantNoteInsertBody {
  customer_id: [number];
  notes: string;
  table: 'h_note';
  created_by: [number];
  important: 0 | 1;
}

export interface ImportantNoteEditBody {
  id: number;
  customer_id: number;
  table: 'h_note';
  notes: string;
}

export interface ImportantNoteUnflagBody {
  id: number;
  customer_id: number;
  table: 'h_note';
  important: 0;
}
